<template lang="pug">
  v-container
    v-row
      v-col
        v-btn(@click="$createOnClick({ onClickManageAssociations })") Gerer les associations
    v-row
      v-col
        v-btn(@click="$createOnClick({ onClickManageThemes })") Gerer les thèmes
    v-row
      v-col
        v-btn(@click="$createOnClick({ onClickDataSeed })") Remettre le jeu initial de données
    v-row
      v-col
        v-btn(@click="$createOnClick({ onClickRequestsToWithdraw })") Gérer les demandes de retrait
    v-row
      v-col
        v-btn(@click="$createOnClick({ onClickManagePercentage })") Gérer le pourcentage
    v-row
      v-col
        v-btn(@click="$createOnClick({ onClickManageDailyMaxViewsCount })") Gérer le nb de soutien max par user
    v-row
      v-col
        v-btn(@click="$createOnClick({ onClickManageAffiliation })") Gérer les affiliations
</template>

<script>
import { page } from '@iez/core'
import router from '@iez/core/router'

const route = {
  name: `ManageYako`,
  path: `/manage-yako`
}

export default {
  ...route,

  setup () {
    page.topBar.set({
      title: `Gestion de Yako`
    })

    const onClickManageAssociations = () => {
      router.push({ name: `ManageAssociations` })
    }
    const onClickManageThemes = () => {
      router.push({ name: `ManageThemes` })
    }
    const onClickDataSeed = () => {
      router.push({ name: `ManageDataSeed` })
    }
    const onClickRequestsToWithdraw = () => {
      router.push({ name: `ManageRequestsToWithdraw` })
    }
    const onClickManagePercentage = () => {
      router.push({ name: `ManagePercentage` })
    }
    const onClickManageDailyMaxViewsCount = () => {
      router.push({ name: `ManageDailyMaxViewsCount` })
    }
    const onClickManageAffiliation = () => {
      router.push({ name: `ManageAffiliation` })
    }

    return {
      onClickManageAssociations,
      onClickManageThemes,
      onClickDataSeed,
      onClickRequestsToWithdraw,
      onClickManagePercentage,
      onClickManageDailyMaxViewsCount,
      onClickManageAffiliation
    }
  }
}
</script>
